module.exports = __webpack_public_path__ + "images/f58705e6420d7b3dd54972034d4fa0e7.png";